/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { TestModel } from '@tripian/model';
import { Button, PreLoading } from '@tripian/react';
import config from '../../config';

import { CREATE_TRIP, OVERVIEW, TRIP_PLAN } from '../../constants/ROUTER_PATH_TITLE';

import AppNav from '../../App/AppNav/AppNav';
import { initialTestTripProfileStr } from './initialTestTripProfile';
import useTripTest from '../../hooks/useTripTest';
import { clear } from '../../redux/action/trip';

import './CreateUpdateTrip.scss';

const CreateTripPage = () => {
  const [tripProfileStr, setTripProfileStr] = useState<string>(initialTestTripProfileStr);
  const [tripProfile, setTripProfile] = useState<TestModel.ITestTripProfile | undefined>(JSON.parse(initialTestTripProfileStr));

  const [message, setMessage] = useState<string>('');

  const { tripAddTest, loadingTripAdd } = useTripTest();
  document.title = `${CREATE_TRIP.TITLE}`;

  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clear());
  }, [dispatch]);

  const onChangeTripProfile = (str: string) => {
    setTripProfileStr(str);
    try {
      setMessage('');
      const newTripProfileParam: TestModel.ITestTripProfile = JSON.parse(str);
      setTripProfile(newTripProfileParam);
    } catch (er: any) {
      setTripProfile(undefined);
      setMessage(er.message.toString());
    }
  };

  const onTripAdd = () => {
    if (tripProfile) {
      tripAddTest(tripProfile, 0).then((trip: TestModel.ITestTripReponse) => {
        const hash: string = trip.trip_hash || '';
        if (config.HIDE_OVERVIEW) history.push(`${TRIP_PLAN.PATH}/${hash}`);
        else history.push(`${OVERVIEW.PATH}/${hash}`);
      });
    } else {
      setMessage('Invalid object!');
    }
  };

  return (
    <>
      <AppNav header={CREATE_TRIP.HEADER} />
      <div className="container py12">
        {loadingTripAdd ? (
          <div className="create-update-trip-loading">
            <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
          </div>
        ) : null}

        <div className="row center">
          <textarea value={tripProfileStr} onChange={(e) => onChangeTripProfile(e.target.value)} rows={40} style={{ width: '100%', height: '100%' }} />
          {message !== '' ? message : null}
        </div>

        <div className="row center">
          <div>
            <Button color="primary" style={{ marginRight: '1rem' }} text="Create My Trip" onClick={onTripAdd} />

            <Button color="secondary" style={{ marginRight: '1rem' }} text="Reload" onClick={() => onChangeTripProfile(initialTestTripProfileStr)} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTripPage;
